import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@/utils/rtkHelper";

// export interface AccountSearch {
//   startAt: number;
//   pageSize: number;
//   sortDesc: boolean;
//   company_id: string;
//   filter_groups: any[];
// }

// export interface AccountSearchResult {
//   items: Account[];
//   pageSize: number;
//   startAt: number;
//   sortDesc: boolean;
//   total: number;
// }

// interface Account {
//   id: number;
//   name: string;
//   account_type_name: string;
//   is_system_account: boolean;
//   code: string;
// }
export interface meesagebox {
  name: string;
  email: string;
  subject: string;
  message: string;
  mobile_no:string;
}
export interface messageSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
  filter_groups: any[];
  sorting: any[];
}

export interface messageSearchResult {
  items: meesagebox[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}

export const messageApi = createApi({
  reducerPath: 'messageApi',
  baseQuery: customBaseQuery,
  tagTypes: ["message"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    createmessage: builder.mutation<void, any>({
      query: (input) => ({
        url: `/message`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["message"],
    }),
    searchMessageBox: builder.query<messageSearchResult, messageSearch>({
        query: (input) => ({
          url: `/message/search`,
          method: "POST",
          body: { ...input, export: false },
        }),
        providesTags: ["message"],
      }),
    exportMessageBox: builder.mutation<Blob, messageSearch>({
        query: (input) => ({
          url: `/message/search`,
          method: "POST",
          body: { ...input, export: true },
          responseHandler: (response: Response) => response.blob(),
        }),
      }),
  }),
  
});

export const { 
  useCreatemessageMutation ,
  useSearchMessageBoxQuery,
  useExportMessageBoxMutation,
} = messageApi;
